export default __webpack_public_path__ + "static/media/ccna.796fde51.png";